import { RegisterPage } from "@/features/auth/pages/Register";

const Register = () => {
  return <RegisterPage />;
};

export default Register;
